export default __webpack_public_path__ + "static/media/pineapple.bd8ea45f.jpg";